import React, { useContext } from 'react'
import { getBadgeTheme, getProductTag } from '@helpers/products'
import PriceComparison from '@components/ui/PriceComparison'
import Badge from '@components/ui/Badge'
import ProductType from '@components/ui/ProductType'
import YotpoStarRating, {
  YotpoStarRatingProps
} from '@components/product/yotpoRatings/YotpoStarRatings'
import { PRODUCT_TYPE_TAGS } from '@consts/index'
import classNames from 'classnames'
import { ProductWithVariants } from 'types/product'
import ProductContext from '../context'
import productHeader from './productHeader.module.scss'


const badgeIcons = {
  'pre-order': 'alarm',
  organic: 'organic'
} as const

const badgeType = {
  organic: 'outline'
} as const

const badgeProps = (tag: string) => {
  const tagToLowerCase = tag.toLowerCase()
  return {
    title: tag,
    themeColour: getBadgeTheme(tagToLowerCase),
    iconName: badgeIcons[tagToLowerCase as keyof typeof badgeIcons],
    badgeType: badgeType[tagToLowerCase as keyof typeof badgeType],
    small: true
  }
}

type ProductHeaderProps = {
  product: ProductWithVariants
  byline: string
  classes?: string
  isAbTestMadeToOrderOxfords?: boolean
} & { starRatings?: YotpoStarRatingProps['starRatings'] }

const ProductHeader = ({
  product,
  byline = '',
  starRatings,
  classes = undefined,
  isAbTestMadeToOrderOxfords
}: ProductHeaderProps) => {
  const { discount } = useContext(ProductContext)

  const showStarRating = !!starRatings && starRatings.total_review > 0
  const productTags = !!product && product.tags.split(',')
  const tagName = getProductTag(productTags, PRODUCT_TYPE_TAGS)
  const isBeta = tagName ? /Beta/.test(tagName) : false

  const productHeaderContainer = classNames(
    productHeader.productHeader__container,
    classes
  )

  return (
    <div className={productHeaderContainer}>
      <div className={productHeader.productHeader__tagTop}>
        {isAbTestMadeToOrderOxfords ? (
          <Badge
            badgeType="filled"
            themeColour={getBadgeTheme('organic')}
            title="Made to order"
            small
          />
        ) : (
          <>
            {tagName && !isBeta && <Badge {...badgeProps(tagName)} />}
            {discount.title && (
              <Badge
                badgeType="filled"
                themeColour={getBadgeTheme('discount')}
                title={discount.title}
                small
              />
            )}
          </>
        )}
      </div>
      <header className={productHeader.productHeader__headlineContainer}>
        <h1 className={productHeader.productHeader__title}>
          <ProductType text={product.product_type} />
        </h1>{' '}
        {isBeta && (
          <Badge iconName="beta-tag" badgeType="minimal" classes="badge_beta" />
        )}
      </header>
      <h3 className={productHeader.productHeader__byline}>{byline}</h3>
      <div className={productHeader.productHeader__row}>
        {showStarRating && <YotpoStarRating starRatings={starRatings} />}
        {!!product.price && (
          <div className={productHeader.ProductHeader__prices}>
            <PriceComparison
              price={product.price}
              fullPrice={product.compare_at_price}
              size="medium-bold"
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ProductHeader
